import React, {useContext, useState} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SearchComponent from '../../../common/SearchComponent/SearchComponent';
import {catalogueApi} from '../../../services/CatalogueServices';
import {Form, Formik} from 'formik';
import {Button, Card, Grid} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import ConservationEntryOne from './ConservationEntryOne';
import ConservationEntryTwo from './ConservationEntryTwo';
import ConservationEntryThree from './ConservationEntryThree';
import BeforeConservationPhoto from '../../../common/ConservationImages/BeforeConservationPhoto';
import AfterConservationPhoto from '../../../common/ConservationImages/AfterConservationPhoto';
import {conservationApi} from '../../../services/ConservationServices';
import {SNACKBAR_OPEN} from '../../../reducers';
import {DispatchContext} from '../../../store';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

export default function AddConservation() {
  const navigate = useNavigate();
  const dispatch = useContext(DispatchContext);
  const [conservation, setConservation] = useState([]);
  const [searched, setSearched] = useState(false);
  const availableData = conservation?.[0];
  const [beforeImgIds, setBeforeImgIds] = useState([]);
  const code = 'en';

  const handleSearch = (searchAccession) => {
    if (searchAccession.trim() !== '') {
      catalogueApi('get', null, {search: searchAccession}).then(res => {
        setConservation(res?.data || []);
        setSearched(true);
      })
    }
  }

  const handleClear = () => {
    setConservation([]);
  }

  const onSubmit = (values) => {
    const initialValues = {
      museum_id: values?.museum_id,
      accession_no: values?.accession_no,
      catalogue_id: values?.id,
      incoming_date: values?.incoming_date,
      completion_date: values?.completion_date,
      before_photo_ids: beforeImgIds?.map((val) => val),
      translations: {
        en: {
          condition_assessment: values?.condition_assessment,
          treatment_plan: values?.treatment_plan
        }
      }
    }

    conservationApi('post', {...initialValues}).then(res => {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Conservation created successfully'}
      });
      setSearched(false);
      if (res?.data?.id) {
        navigate(`/management/conservators/${res?.data?.id}`);
      }
    })
  }

  return (
    <PageWrapper>
      <Box sx={{display: {sm: 'flex', xs: 'column'}, alignItems: 'center', mt: 7, mb: 2}}>
        <Typography className={'text-500 font30'} sx={{color: '#757575'}}>Add Conservation</Typography>
        <Box sx={{ml: {sm: 5, xs: 0}}}>
          <SearchComponent onSearch={handleSearch} searched={searched} setSearched={setSearched}
                           onClear={handleClear} placeholder={'Enter accession number'}/>
        </Box>
      </Box>
      <Box className={'header-divider'}/>
      <Formik initialValues={availableData}
              onSubmit={onSubmit}
              validateOnBlur={true} enableReinitialize
      >
        {({isSubmitting, touched, errors, values, setFieldValue, ...formik}) => (
          <Form>
            {searched &&
            <Box sx={{mb: {sm: 4, xs: 2}}}>
              <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                  <ConservationEntryOne code={code}/>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <ConservationEntryTwo code={code}/>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <ConservationEntryThree code={code}/>
                </Grid>
              </Grid>
              <Box className={'dotted-divider'}/>
              <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                  <Card className={'box-shadow'} sx={{p: 4}}>
                    <Typography><span style={{color: 'red'}}>*</span>Upload Before Photo</Typography>
                    <BeforeConservationPhoto setImageId={setBeforeImgIds} conservationImgId={beforeImgIds}/>
                  </Card>
                </Grid>
              </Grid>
              <Box>
                <Grid container spacing={2}>
                  <Grid item sm={9} xs={12}/>
                  <Grid item sm={3} xs={12}>
                    <Grid container spacing={2}>
                      <Grid item sm={6} xs={12}>
                        <Button onClick={() => navigate(-1)} variant={'outlined'} color={'error'}
                                fullWidth>Cancel</Button>
                      </Grid>
                      <Grid item sm={6} xs={12}>
                        <Button variant={'contained'} type={'submit'} fullWidth>Submit</Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            }
          </Form>
        )}
      </Formik>
    </PageWrapper>
  );
}